import React from "react";
import { DatePicker } from "antd";
import "./MonthSelector.css";

const { MonthPicker } = DatePicker;

function MonthSelector({ value, onChange, className, bordered = true }) {
  return (
    <MonthPicker
      value={value}
      onChange={(val) => val && onChange(val)}
      format="MMMM YYYY"
      className={"month-selector" + (className ? " " + className : "")}
      allowClear={false}
      bordered={bordered}
    />
  );
}

export default MonthSelector;
